export const downloadFileFromUrl = ({ url }: { url: string }) => {
  const link = document.createElement('a');
  link.href = url;
  link.click();
};
